import { differenceDaysLength } from '../machine-date-utils';

import type { DateTime } from '@shared/types/utils';

const stayLength = ({
  checkIn,
  checkOut,
}: {
  checkIn: DateTime;
  checkOut: DateTime;
}) => differenceDaysLength(checkOut, checkIn);

export default stayLength;
